// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/* tslint:disable */
/**
 * The inspector panel token.
 */
export const IInspector = new Token('@jupyterlab/inspector:IInspector');
//# sourceMappingURL=tokens.js.map